<template>
    <Transition>
        <div style="margin-right: 10px;" v-if="candidate">
        
        <div class="form container px-2">

        <h5><b>F. UNIVERSITY ADMINISTRATION</b></h5>

        <!--university admin-->
        <div class="mb-4 text-start">
            <div class="mb-3 d-flex align-items-center">
                <b>
                    F.1 &nbsp;Deanship/Directorship/Coordinatorship/ Headship, in this University, with
                    dates:
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#universityAdmin"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=universityAdmins :type="'universityAdmins'" />
        </div>

        <!-- university admin Modal -->
        <div class="modal fade" id="universityAdmin" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel12">University Administration</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="exampleFormControlInput124" class="form-label me-3">Describe Position:</label>
                            <textarea rows="5" v-model="universityAdmin" type="text" class="form-control"
                                id="exampleFormControlInput4"></textarea>
                        </div>
                        <div class="mb-3 d-flex">
                            <label for="universityAdminSessionText" class="form-label">Number of sessions/years:</label>
                            &nbsp;
                            <span>
                                <input style="width: 100px" v-model="universityAdminSessions" type="number"
                                    class="form-control" id="universityAdminSessionText">
                            </span>
                        </div>
                        <br>
                        <div>
                            <label for="universityAdminUrl" class="form-label">Google Drive Link:</label>
                            <input v-model="universityAdminUrl" type="text" class="form-control" id="universityAdminUrl">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('universityAdmin')" type="button" class="btn btn-success"
                            data-bs-dismiss="modal">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <!--committee Membership-->
        <div class="mb-4 text-start">
            <div class="mb-3 d-flex">
                <b>
                    F.2 Membership of University/Faculty/ Department Committees, in this University,
                    with dates:
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#committeeMembership"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=committeeMemberships :type="'committeeMemberships'" />
        </div>

        <!-- committee Membership Modal -->
        <div class="modal fade" id="committeeMembership" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel12">Committee Membership</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="exampleFormControlInput124" class="form-label me-3">Committee Membership
                                Details:</label>
                            <textarea rows="5" v-model="committeeMembership" type="text" class="form-control"
                                id="exampleFormControlInput4"></textarea>
                        </div>
                        <div class="mb-3 d-flex">
                            <label for="committeeMembershipSessionText" class="form-label">Number of sessions/years:</label>
                            &nbsp;
                            <span>
                                <input style="width: 100px" v-model="committeeMembershipSessions" type="number"
                                    class="form-control" id="committeeMembershipSessionText">
                            </span>
                        </div>
                        <br>
                        <div>
                            <label for="committeeMembershipUrl" class="form-label">Google Drive Link:</label>
                            <input v-model="committeeMembershipUrl" type="text" class="form-control" id="committeeMembershipUrl">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('committeeMembership')" type="button" class="btn btn-success"
                            data-bs-dismiss="modal">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <!--other services-->
        <div class="mb-4 text-start">
            <div class="mb-3 d-flex align-items-center">
                <b>
                    F.3 &nbsp;Hall Mastership/Student Advisory/ SIWES/Laboratory Organization/Other
                    internal University Services, in this University with dates:
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#otherService"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=otherServices :type="'otherServices'" />
        </div>

        <!-- other services Modal -->
        <div class="modal fade" id="otherService" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel12">Other Internal University Services</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="otherService" class="form-label me-3">
                                Details of service:</label>
                            <textarea rows="5" v-model="otherService" type="text" class="form-control"
                                id="otherService"></textarea>
                        </div>
                        <div class="mb-3 d-flex">
                            <label for="otherServiceSessionText" class="form-label">Number of sessions/years:</label>
                            &nbsp;
                            <span>
                                <input style="width: 100px" v-model="otherServiceSessions" type="number"
                                    class="form-control" id="otherServiceSessionText">
                            </span>
                        </div>
                        <br>
                        <div>
                            <label for="otherServiceUrl" class="form-label">Google Drive Link:</label>
                            <input v-model="otherServiceUrl" type="text" class="form-control" id="otherServiceUrl">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('otherService')" type="button" class="btn btn-success"
                            data-bs-dismiss="modal">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-row-reverse my-5">
            <button @click="saveSection('next')" type="button" class="btn btn-success">Save & Continue</button>
            <button @click="saveSection('previous')" type="button" class="btn btn-success me-3">Previous Section</button>
        </div>
    </div>
    </div>
</Transition>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'sectionF',
    emits: ['toggleLoader', 'setSection'],
    data() {
        return { candidate: '',
            universityAdmin: '',
            universityAdminUrl: '',
            universityAdminSessions: 1,
            universityAdmins: [],
            committeeMembership: '',
            committeeMembershipUrl: '',
            committeeMembershipSessions: 1,
            committeeMemberships: [],
            otherService: '',
            otherServiceUrl: '',
            otherServiceSessions: 1,
            otherServices: [],
            key: 0
        }
    },
    created() {
        this.$emit('setSection', 'Section F');
        this.setData()
    },
    methods: {
        resetEdit(){
            //removes edit section if present on the page
            for (var i=0; i < this.universityAdmins.length; i++) {
                this.universityAdmins[i].editing = false
            }
            for (var i=0; i < this.committeeMemberships.length; i++) {
                this.committeeMemberships[i].editing = false
            }
            for (var i=0; i < this.otherServices.length; i++) {
                this.otherServices[i].editing = false
            }
        },
        
        setDetails(candidate) {
            this.candidate = candidate;
            this.universityAdmins = candidate.academicStaff.universityAdmins ? candidate.academicStaff.universityAdmins : [];
            this.committeeMemberships = candidate.committeeMemberships ? candidate.committeeMemberships : [];
            this.otherServices = candidate.academicStaff.otherServices ? candidate.academicStaff.otherServices : [];
        },
        async saveSection(page) {
            this.$emit('toggleLoader');
            var dataDetails = {
                universityAdmins: this.universityAdmins,
                committeeMemberships: this.committeeMemberships,
                otherServices: this.otherServices
            }

            const candidate = await DataService.saveData(dataDetails);
            
            if (candidate) {
                this.setDetails(candidate)
                if (page == 'previous') {
                    this.$router.push('/sectione')
                } else if (page == 'next') {
                    this.$router.push('/sectiong')
                }
            }

            this.$emit('toggleLoader');
        },
        async setData() {
            window.scrollTo({ top: 0, behavior: 'smooth' });

            this.$emit('toggleLoader');

            const candidate = await DataService.getCandidate(JSON.parse(window.localStorage['user'])._id, 'sectionF');

            if (candidate) { 
                this.setDetails(candidate);
            }
        
            this.$emit('toggleLoader');
        },
        joinDetails(category) {
            if (category == 'universityAdmin' && this.universityAdmin) {
                this.universityAdmins.unshift({ data: this.universityAdmin, fileUrl: this.universityAdminUrl, sessionNum: this.universityAdminSessions });
                this.universityAdmin = '';
                this.universityAdminSessions = 1;
            } else if (category == 'committeeMembership' && this.committeeMembership) {
                this.committeeMemberships.unshift({ data: this.committeeMembership, fileUrl: this.committeeMembershipUrl, sessionNum: this.committeeMembershipSessions });
                this.committeeMembership = '';
                this.committeeMembershipSessions = 1;
            } else if (category == 'otherService' && this.otherService) {
                this.otherServices.unshift({ data: this.otherService, fileUrl: this.otherServiceUrl, sessionNum: this.otherServiceSessions });
                this.otherService = '';
                this.otherServiceSessions = 1;
            }
            this.key += 1
        },
    }
}
</script>